/* NOTE:
global This file can be replaced during build by using the `fileReplacements` array.
`ng build` replaces `environment.ts` with `environment.prod.ts`.
The list of file replacements can be found in `angular.json`. */
import { Environment, EnvironmentType } from '@fleet-beat/core';

export const environment: Environment = {
  type: EnvironmentType.PROD,
  identityApiUrl: 'https://dev.api.fleetbeat.xyz/identity',
  tenantsApiUrl: 'https://dev.api.fleetbeat.xyz/tenants',
  tenantsHubUrl: 'https://dev.api.fleetbeat.xyz/tenants-hub',
  assetsApiUrl: 'https://dev.api.fleetbeat.xyz/assets',
  assetsHubUrl: 'https://dev.api.fleetbeat.xyz/assets-hub',
  mapsApiUrl: 'https://dev.api.fleetbeat.xyz/maps',
  mapsHubUrl: 'https://dev.api.fleetbeat.xyz/maps-hub',
  metricsApiUrl: 'https://dev.api.fleetbeat.xyz/metrics',
  mapboxAccessToken: 'pk.eyJ1IjoiZmxlZXRiZWF0IiwiYSI6ImNtcG5seDMweDAwbGUyeHIybTZtYmM4NWsifQ.UztCZPfCQ1os3L-L0BlNew',

  // eslint-disable-next-line no-comments/disallowComments
  // ----------   new API
  apiEndpoint: 'https://dev.api.fleetbeat.xyz/api/v1',
  messagingHubUrl: 'wss://dev.api.fleetbeat.xyz',
  stripeKey:
    'pk_test_51TOozeQvjZJjVZhg44h7lY4tgIttLxV3qZvQ8bm5KASg6LSHCdILbBDVssqq7tkM7HUa6AVqMf2SIo65CCkQJDCU00BxfGuNmX',
  assistantReportsApiKey: '3157c539d8fce1569fb6e5c67b7eaf6286fd6e6ffb1feff1fc0e860cd3508d61',
};

/* NOTE:
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// NOTE: import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
